import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "theme-tag" }
const _hoisted_2 = { class: "theme-tag_pop" }
const _hoisted_3 = ["onClick"]

import { useStorage, useToggle } from "@vueuse/core";
import { themeList } from "./infoConfig";
import { IonPopover, IonContent, popoverController } from "@ionic/vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ThemeTag',
  setup(__props) {

const [themeVis, changeThemeVis] = useToggle();

const currentTheme = useStorage("ai-theme", "brown", localStorage);

async function changeTheme(theme: string) {
  currentTheme.value = theme;
  await popoverController.dismiss();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: "trigger-button",
      class: "flex-column align-center justify-center",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(changeThemeVis) && _unref(changeThemeVis)(...args)))
    }, _cache[1] || (_cache[1] = [
      _createElementVNode("i", { class: "iconfont icon-zhuti right-bar_icon" }, null, -1),
      _createElementVNode("span", { class: "operate-text" }, "主题", -1)
    ])),
    _createVNode(_unref(IonPopover), {
      "is-open": _unref(themeVis),
      arrow: false,
      "show-backdrop": false,
      trigger: "trigger-button",
      "trigger-action": "click"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(themeList), (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.value,
                class: "theme-pop-item",
                onClick: ($event: any) => (changeTheme(item.value))
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["theme-pop-item_icon", [item.class, _unref(currentTheme) === item.value ? item.activeClass : '']])
                }, null, 2)
              ], 8, _hoisted_3))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["is-open"])
  ]))
}
}

})